import axios from 'axios';
import {API_URL} from '../config/constants';
import SpringDataPage, {BasicPage} from '../@types/spring-data-page';
import {getErrorMessage} from '../utils/utils';
import NewOccurrenceReport from '../@types/new-occurrence-report';


class FoundryService {
    static foundryUrlV2 = API_URL + 'api/v2/foundry';

    formOccurrence(occurrence: any): NewOccurrenceReport {
        let occur: NewOccurrenceReport = {} as NewOccurrenceReport;
        occur.id = occurrence.id;
        occur.uniqueId = occurrence.uniqueId;
        occur.content = occurrence.content;
        occur.dateTime = occurrence.datetime;
        occur.created = occurrence.created;
        occur.summary = occurrence.summary;
        occur.sourceName = occurrence.sourceName;
        return occur;
    }

    formOccurrencesPagePromise(occurrencesData: any): Promise<SpringDataPage<NewOccurrenceReport>> {
        let occurrencesPage: SpringDataPage<NewOccurrenceReport> = {} as SpringDataPage<NewOccurrenceReport>;
        if (occurrencesData) {
            if (occurrencesData._embedded?.reportDTOList) {
                occurrencesPage.content = occurrencesData._embedded.reportDTOList?.map((occurrence: any) => this.formOccurrence(occurrence));
            } else {
                occurrencesPage.content = [];
            }
            occurrencesPage.page = occurrencesData.page;
        }

        return Promise.resolve(occurrencesPage);
    }

    fetchEvents(page: BasicPage, searchTerm?: string, sourceNames?: string[]): Promise<SpringDataPage<NewOccurrenceReport>> {
        let url = `${FoundryService.foundryUrlV2}/events?`
            + `size=${page.size}&`
            + `page=${page.offset}&`
            + `sort=${page.sort},${page.direction}`;

        if (searchTerm && searchTerm !== '') {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }
        if (sourceNames && sourceNames.length > 0) {
            sourceNames.forEach(name => {
                url += `&sourceNames=${encodeURIComponent(name)}`;
            });
        }

        return axios
            .get(url, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => {
                return this.formOccurrencesPagePromise(response.data);
            })
            .catch(err => {
                throw new Error('Failed to get occurrences: ' + getErrorMessage(err));
            })
    }

    fetchEventByUniqueId(uniqueId: string): Promise<NewOccurrenceReport> {
        let url = `${FoundryService.foundryUrlV2}/events/${uniqueId}`;
        return axios
            .get(url, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => {
                return Promise.resolve(this.formOccurrence(response.data));
            })
            .catch(err => {
                throw new Error(`Failed to get occurrence ${uniqueId} ` + getErrorMessage(err));
            })
    }

    getEventSources(): Promise<{sourceName: string; reportCount: number}[]> {
        return axios
            .get(`${FoundryService.foundryUrlV2}/events/sources`, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.data as {sourceName: string; reportCount: number}[])
            .catch(err => {
                throw new Error('Failed to get event sources: ' + getErrorMessage(err));
            });
    }

    importFoundryEvents(sourceName: string): Promise<any> {
        const url = `${FoundryService.foundryUrlV2}/events/import?sourceName=${encodeURIComponent(sourceName)}`;
        return axios
            .post(url, {}, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.data)
            .catch(err => {
                throw new Error('Failed to import foundry events: ' + getErrorMessage(err));
            });
    }
}

export default new FoundryService();